import traverse from "@babel/traverse";
import * as parser from "@babel/parser";
import { readFileSync } from "fs";
import { Symbol } from "../../interfaces";

const getFileType = (path: string) => {
  const extension = path.split(".").pop();
  if (extension === "js") {
    return "JS";
  } else if (extension === "ts") {
    return "TS";
  } else if (extension === "tsx") {
    return "TSX";
  } else if (extension === "jsx") {
    return "JSX";
  }
  return "UNSUPPORTED";
};

function getAST(path: string) {
  const fileType = getFileType(path);

  const isTS = fileType === "TSX";
  const additionalPlugin = isTS ? "typescript" : "flow";
  const code = readFileSync(path, "utf-8");
  return parser.parse(code, {
    sourceType: "module",
    plugins: [
      "jsx",
      "classProperties",
      "dynamicImport",
      "nullishCoalescingOperator",
      "optionalChaining",
      additionalPlugin,
    ],
  });
}

export function parse(filePath: string) {
  const ast = getAST(filePath);
  const symbol: Symbol[] = [];

  traverse(ast, {
    FunctionDeclaration: (path) => {
      symbol.push({
        name: path.node.id?.name || "",
        fileName: filePath,
        loc: path.node.id?.loc,
      });
    },
    InterfaceDeclaration: (path) => {
      symbol.push({
        name: path.node.id?.name || "",
        fileName: filePath,
        loc: path.node.id?.loc,
      });
    },
    VariableDeclarator: (path) => {
      symbol.push({
        name: (path.node.id as any).name || "",
        fileName: filePath,
        loc: path.node.id?.loc,
      });
    },
  });

  return symbol;
}

export function getSymbolFromFile(path: string, symbolName: string) {
  const symbols = parse(path);
  return symbols.find((s) => s.name === symbolName);
}
